var map = {
	"./GoogleStore.svg": "5d3a",
	"./accountEditUserNameIcon.svg": "b7f2",
	"./ad-bg.svg": "d83a",
	"./addsquare.svg": "e6a8",
	"./apple.svg": "5a94",
	"./apply-merchant-icon.svg": "f769",
	"./arrow-right.svg": "0d93",
	"./assets-exchange-opt-icon.svg": "cb85",
	"./backtop.svg": "0e95",
	"./checkedBox.svg": "3201",
	"./circle-arrow-color.svg": "da69",
	"./circle-arrow.svg": "c0a4",
	"./clear.svg": "eed3",
	"./close.svg": "741a",
	"./customer.svg": "12b4",
	"./empty.svg": "dea2",
	"./footer-active-icon-1.svg": "3355",
	"./footer-active-icon-2.svg": "6b3a",
	"./footer-active-icon-3.svg": "1dc9",
	"./footer-active-icon-4.svg": "fa00",
	"./footer-active-icon-5.svg": "cb16",
	"./footer-active-icon-6.svg": "e4e9",
	"./footer-icon-1.svg": "809f",
	"./footer-icon-2.svg": "899a",
	"./footer-icon-3.svg": "5fd5",
	"./footer-icon-4.svg": "b45a",
	"./footer-icon-5.svg": "065c",
	"./footer-icon-6.svg": "803e",
	"./google.svg": "63dc",
	"./icon-ali.svg": "f07f",
	"./icon-bank.svg": "a8b1",
	"./icon-circle-answer.svg": "9696",
	"./icon-customer-service.svg": "b06a",
	"./icon-image.svg": "7430",
	"./icon-mingcute_vip.svg": "46d5",
	"./icon-paper-plane.svg": "d530",
	"./icon-right-answer.svg": "901f",
	"./icon-sort-down.svg": "7c5d",
	"./icon-sort-up.svg": "8909",
	"./icon-sort.svg": "b5d4",
	"./icon-trans.svg": "63eb",
	"./icon-video.svg": "6e7f",
	"./icon-wechat.svg": "1dd4",
	"./icon-wrong-answer.svg": "0a4a",
	"./icon_GooglePlay.svg": "f9f9",
	"./icon_invisible.svg": "259f",
	"./icon_shield-lock.svg": "e290",
	"./icon_visible.svg": "fcec",
	"./language.svg": "a4fa",
	"./logo.svg": "9153",
	"./notice.svg": "a356",
	"./notification.svg": "df0d",
	"./personal_email.svg": "be9d",
	"./personal_fee.svg": "b12e",
	"./personal_google_verify.svg": "d41a",
	"./personal_invite.svg": "fdaa",
	"./personal_login_password_icon.svg": "d5d2",
	"./personal_phone.svg": "6647",
	"./personal_shieldtick.svg": "1c1e",
	"./qrcode.svg": "faed",
	"./radio-checked.svg": "801d",
	"./radio-uncheck.svg": "e65e",
	"./rechargeTips.svg": "727a",
	"./resetCopyIcon.svg": "abf1",
	"./search.svg": "f264",
	"./selected.svg": "d5f0",
	"./service-four.svg": "d58f",
	"./service-one.svg": "6fe6",
	"./service-three.svg": "1f5b",
	"./service-two.svg": "b06c",
	"./star-active.svg": "1e93",
	"./star-default.svg": "fd43",
	"./stop.svg": "0eec",
	"./switch-moon.svg": "eca8",
	"./switch-sun.svg": "d4e2",
	"./tip-error.svg": "8104",
	"./tip-success.svg": "0c4f",
	"./warningIcon.svg": "eaa4",
	"./wechat-bind.svg": "04c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63f0";